import * as Yup from "yup";
import {toast} from "react-toastify";
import React, {useEffect, useRef, useState} from "react";
import messageTypes from "../../../constants/MessagesTypes";
import {Form} from "@unform/web";
import CustomButton from "../../../components/Form/Button";
import {Link, useHistory} from "react-router-dom";
import {BiArrowBack} from "react-icons/bi";
import {IoMdCheckmark} from "react-icons/io";
import {edit, getStrategy, save} from "../../../services/Strategy";
import Input from "../../../components/Form/Input";
import {useTranslation} from "react-i18next";
import DivDiagonal from "../../../components/DivDiagonal";
import {
    TradingWrapper,
    ContentArea,
    TradingCard,
    HeaderActions,
    NewTradingButton,
} from "../../Trading/styles";
import {StrategyPageHeader, StrategyFormNarrow} from "../styles";
import {StyledFormWrapper, ButtonContainer, FormRow} from "../../Trading/New/styles";

const backBtnStyle = {
    background: 'rgba(255, 255, 255, 0.05)',
    border: '2px solid rgba(255, 255, 255, 0.2)',
    color: '#e0e0e0',
    padding: '14px 28px',
    borderRadius: '10px',
    fontWeight: 600,
    transition: 'all 0.3s ease',
};

const saveBtnStyle = {
    background: 'linear-gradient(135deg, #f29205 0%, #ff6b35 100%)',
    border: 'none',
    color: '#ffffff',
    padding: '14px 32px',
    borderRadius: '10px',
    fontWeight: 600,
    boxShadow: '0 4px 15px rgba(242, 146, 5, 0.3)',
    transition: 'all 0.3s ease',
};

export default function NewStrategy({match}) {
    const [saving, setSaving] = useState(false);
    const [fetching, setFetching] = useState(false);
    const [strategy, setStrategy] = useState(0);
    const formRef = useRef(null);
    const history = useHistory();
    const { t } = useTranslation();
    const editId = match.params.id;

    async function handleSubmmit(data) {
        try {
            if (saving) {
                return;
            }

            setSaving(true);
            formRef.current.setErrors({});
            const schema = Yup.object().shape({
                name: Yup.string().required(t('input_required')),
            });

            await schema.validate(data, {
                abortEarly: false,
            });

            const formData = new FormData();
            formData.append('name', data.name);
            const response =
                strategy && strategy.id ? await edit(strategy.id, formData) : await save(formData);

            if (response && response.status === 200) {
                toast.success(messageTypes.SUCCESS);
                history.push('/estrategias');
            } else {
                toast.error(messageTypes.ERROR_SAVE);
            }
            setSaving(false);

        } catch (err) {
            setSaving(false);
            if (err instanceof Yup.ValidationError) {
                const validationErrors = {};
                err.inner.forEach((error) => {
                    validationErrors[error.path] = error.message;
                });
                formRef.current.setErrors(validationErrors);
                toast.warning(messageTypes.REQUIRED_FIELDS);
                return;
            }

            toast.error(messageTypes.ERROR);
        }
    }

    useEffect(() => {
        if (!editId) {
            return;
        }
        setFetching(true);
        getStrategy(editId).then((data) => {
            setStrategy(data);
        }).finally(() => setFetching(false));
    }, [editId]);

    const isEdit = Boolean(strategy && strategy.id);
    const showForm = !editId || (strategy && strategy.id);

    return (
        <TradingWrapper>
            <DivDiagonal />
            <ContentArea>
                <StrategyPageHeader>
                    <h1>
                        <i className={`fas ${isEdit ? 'fa-edit' : 'fa-plus'}`} aria-hidden="true"/>
                        {' '}
                        {isEdit ? t('strategy_card_edit_title') : t('strategy_card_new_title')}
                    </h1>
                    <HeaderActions>
                        <NewTradingButton as={Link} to="/estrategias">
                            <i className="fas fa-list" aria-hidden="true"/> {t('strategy_card_title')}
                        </NewTradingButton>
                    </HeaderActions>
                </StrategyPageHeader>

                <StrategyFormNarrow>
                    <TradingCard>
                        {editId && fetching ? (
                            <StyledFormWrapper>
                                <div style={{ textAlign: 'center', padding: '40px 16px', color: 'rgba(255,255,255,0.65)' }}>
                                    {t('loading')}
                                </div>
                            </StyledFormWrapper>
                        ) : showForm ? (
                            <StyledFormWrapper>
                                <Form ref={formRef} onSubmit={handleSubmmit}>
                                    <FormRow>
                                        <Input
                                            type="text"
                                            name="name"
                                            defaultValue={isEdit ? strategy.name : ''}
                                            label={t('strategy_label_input_name') + ' *'}
                                            placeholder={t('strategy_label_input_name')}
                                        />
                                    </FormRow>

                                    <ButtonContainer>
                                        <Link to="/estrategias" style={{ textDecoration: 'none' }}>
                                            <CustomButton
                                                variant="outlined"
                                                className="btn btn-secondary font-weight-bold text-capitalize mobile-button"
                                                startIcon={<BiArrowBack/>}
                                                style={backBtnStyle}
                                                onMouseEnter={(e) => {
                                                    e.currentTarget.style.background = 'rgba(255, 255, 255, 0.1)';
                                                    e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.3)';
                                                    e.currentTarget.style.transform = 'translateY(-2px)';
                                                }}
                                                onMouseLeave={(e) => {
                                                    e.currentTarget.style.background = 'rgba(255, 255, 255, 0.05)';
                                                    e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.2)';
                                                    e.currentTarget.style.transform = 'translateY(0)';
                                                }}
                                            >
                                                {t('btn_back')}
                                            </CustomButton>
                                        </Link>
                                        <CustomButton
                                            className="btn btn-primary font-weight-bold text-capitalize mobile-button"
                                            loading={saving}
                                            type="submit"
                                            startIcon={<IoMdCheckmark/>}
                                            style={saveBtnStyle}
                                            onMouseEnter={(e) => {
                                                if (!saving) {
                                                    e.currentTarget.style.transform = 'translateY(-2px)';
                                                    e.currentTarget.style.boxShadow = '0 6px 20px rgba(242, 146, 5, 0.4)';
                                                }
                                            }}
                                            onMouseLeave={(e) => {
                                                e.currentTarget.style.transform = 'translateY(0)';
                                                e.currentTarget.style.boxShadow = '0 4px 15px rgba(242, 146, 5, 0.3)';
                                            }}
                                        >
                                            {t('btn_save')}
                                        </CustomButton>
                                    </ButtonContainer>
                                </Form>
                            </StyledFormWrapper>
                        ) : null}
                    </TradingCard>
                </StrategyFormNarrow>
            </ContentArea>
        </TradingWrapper>
    );
}
